// extracted by mini-css-extract-plugin
module.exports = {"trajectory":"trajectory_trajectory_3B6K2","map":"trajectory_map_fDh9R"};